export enum GameState {
    WaitResult = 2,
    Small = 0x7000,
    Big,
    Triple,
}
